import { css, keyframes } from "styled-components";

const animations = {
  // "0-1": { startHeight: 3000, endHeight: 3000, type: "jump" },
  // "1-30000": { startHeight: 3000, endHeight: 100, type: "fall" },
  // "23700-24470": { startHeight: 300, endHeight: 100, type: "jump" },
  "0-7330": { startHeight: 100, endHeight: 100, type: "fall" },
  "7330-7683": { startHeight: 200, endHeight: 200, type: "jump" }, // 300
  "7683-8210": { startHeight: 100, endHeight: 100, type: "fall" }, // 430
  "8210-8560": { startHeight: 200, endHeight: 200, type: "jump" }, // 300

  "8560-9694": { startHeight: 100, endHeight: 100, type: "fall" }, // 935
  "9694-10150": { startHeight: 200, endHeight: 200, type: "jump" }, // 381

  "10150-23500": { startHeight: 200, endHeight: 100, type: "fall" }, // 854

  // "25170-26000": { startHeight: 300, endHeight: 100, type: "fall" },
  // "28100-28850": { startHeight: 300, endHeight: 100, type: "fall" },
  // "28900-29150": { startHeight: 100, endHeight: 10000, type: "jump" },
  // "29150-30000": { startHeight: 300, endHeight: 100, type: "fall" },
};

let lastAnimType = "fall";
let lastKeyframes = [100, 0, 100];

const jump = (props) => keyframes`
  0%  {bottom: ${lastKeyframes[0] + "px"}}
  35%  {bottom: ${lastKeyframes[1] + "px"}}
  100% {bottom: ${lastKeyframes[2] + "px"}}
`;

// const freeFall = (props) => keyframes`
//   0%  {bottom: ${lastKeyframes[0] + "px"}}
//   100% {bottom: ${lastKeyframes[2] + "px"}}
// `;

const fall = (props) => keyframes`
0%  {bottom: ${lastKeyframes[0] + "px"}}
35%  {bottom: ${lastKeyframes[1] + "px"}}
100% {bottom: ${lastKeyframes[2] + "px"}}
`;

const jumpNow = css`
  ${jump} .3s forwards ease-out;
`;

const fallNow = (props) => css`
  ${fall} .3s forwards ease-out;
`;

/** search in `animations` by frame(scroll) */
const determineAnim = (scroll) => {
  let anim = null;
  const currFrame = scroll;
  let animRange;

  Object.keys(animations).some((k) => {
    animRange = k.split("-");

    if (currFrame < animRange[0] || animRange[1] <= currFrame) {
      return false;
    }

    anim = animations[k];
    return true;
  });

  if (anim === undefined || anim === null || anim === "") return false;

  if (lastAnimType === anim.type) return false;

  lastKeyframes = [
    anim.startHeight,
    (anim.endHeight - anim.startHeight) / 2 + anim.endHeight,
    anim.endHeight,
  ];

  lastAnimType = anim.type;
};

/**
 * @param {*} scroll
 */
const getJumpAnimation = (scroll) => {
  determineAnim(scroll);

  return lastAnimType === "jump" ? jumpNow : fallNow;
};

export default getJumpAnimation;
